import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FomanticUIModule } from 'ngx-fomantic-ui';

import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { PipesModule } from './pipes/pipes.module';
import { ResourcesModule } from './resources/resources.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectivesModule,
    FomanticUIModule,
    PipesModule,
    ResourcesModule,
    FlexLayoutModule,
  ],
  exports: [
    CommonModule,
    ComponentsModule,
    DirectivesModule,
    FomanticUIModule,
    PipesModule,
    ResourcesModule,
    FlexLayoutModule,
  ],
})
export class SharedModule {}
